import React, { memo, useMemo } from 'react';
import classnames from 'classnames';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import LinkJump from '@gp/components/LinkJump';
import { getValidDate, queryJumpable } from '@gp/utils/common';
import '@gp/pages/StudioDashboard/StudioOverall/components/LogoList/components/LogoListDetails/index.scss';

interface ILogoListDetailsProps extends IBaseProps {
  className?: string;
  style?: React.CSSProperties;
  logos?: ILogoList;
  defaultLogo?: string;
  isShowDate?: boolean;
  dateFormatter?: (data?: ILogoItem) => string;
  // 跳转
  toDetails?: (
    itemList: any,
    e: React.MouseEvent<Element, MouseEvent> | null,
    isJump: boolean,
  ) => string | undefined;
}

const defaultDateFormatter = (data?: ILogoItem): string => {
  const { date } = data || {};
  return getValidDate(date || '', 'YYYY-MM-DD');
};

const LogoListDetails: React.FC<ILogoListDetailsProps> = (props) => {
  const {
    className,
    style,
    logos = [],
    defaultLogo,
    isShowDate = false,
    dateFormatter = defaultDateFormatter,
    toDetails = null,
  } = props;

  // 是否可以跳转
  const isOnClick = useMemo(() => {
    return !!toDetails && typeof toDetails === 'function';
  }, [toDetails]);

  return (
    <div
      style={style}
      className={classnames(
        'dbg-studio-overall-logo-list-details-comp globalpedia-custom-scrollbar',
        className,
      )}
    >
      <div className="dbg-studio-overall-logo-list-details-list-container">
        <ul className="dbg-studio-overall-logo-list-details-list">
          {logos?.length > 0 &&
            logos?.map((logo, idx) => (
              <li
                key={idx}
                className="dbg-studio-overall-logo-list-details-item"
              >
                <LinkJump url={isOnClick ? toDetails?.(logo, null, false) : ''}>
                  <GeneralImageNew
                    src={logo?.cover || ''}
                    errorImg={defaultLogo}
                    width={40}
                    height={40}
                    className="dbg-studio-overall-logo-img"
                    onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
                      if (!queryJumpable(e) || !isOnClick) return;
                      toDetails?.(logo, e, true);
                    }}
                  />
                </LinkJump>
                <div className="dbg-studio-overall-logo-context">
                  <LinkJump url={isOnClick ? toDetails?.(logo, null, false) : ''}>
                    <div
                      className={`${isOnClick ? 'hover-link' : ''}`}
                      onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
                        if (!queryJumpable(e) || !isOnClick) return;
                        toDetails?.(logo, e, true);
                      }}
                    >
                      <EllipsisTextBubble
                        ellipsisLineClamp={isShowDate ? 1 : 2}
                        text={logo?.name || ''}
                        className="dbg-studio-overall-logo-name"
                        bubbleStyle={{
                          width: 'auto',
                          maxWidth: 'calc(100% - 5px)',
                        }}
                      />
                    </div>
                  </LinkJump>
                  {isShowDate && (
                    <div className='dbg-studio-overall-logo-context-time' style={{ whiteSpace: 'nowrap' }}>
                      {dateFormatter?.(logo)}
                    </div>
                  )}
                </div>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default memo(LogoListDetails);
